import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import {
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";

interface updateShopUser {
  closeDrawer?: Function;
  openUpdate?: Function;
  onRefresh: () => void;
  user?: any;
}

const UpdateUser = (props: updateShopUser) => {
  const { getUserPermission:getUserPermissions} = usePermissionGetter(
    permissionsConstants.admin,
    permissionsConstants.user
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const status = filterConstants.Active;
  const { closeDrawer, openUpdate, user, onRefresh } = props;
  const buttonStyles = useButtonStyles();
  const NavigateToAdmin = () => {
    closeDrawer && closeDrawer(false);
    navigate("/admin");
  };

  const deleteUser = async () => {
    try {
      setLoading(true);
      await axios.delete(
        process.env.REACT_APP_API_URL +
          APIConstants.admin +
          "?email=" +
          user.email
      );
      setUploadError(false);

      navigate("/admin");
      setTimeout(() => {
        closeDrawer && closeDrawer(false);
        onRefresh();
      }, 3000);
    } catch (error) {
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (
    <Grid height={"100%"}>
      <Grid
        height={"15%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
          pl={2}
        >
          {`${user?.firstName} ${user?.lastName}`}
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={closeDrawer ? () => NavigateToAdmin() : () => {}}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid height={"85%"} px={3}>
        <Grid
          border={theme.border?.newGreyBorder}
          sx={{ background: theme.color?.newGreyBackground }}
          borderRadius={"16px"}
          height={"40%"}
          px={3}
          py={4}
        >
          <Grid height={"40%"} display={"flex"} gap={1}>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                First Name
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.firstName || ""}
              </Typography>
            </Grid>
            <Grid width={"30%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Last Name
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.lastName || ""}
              </Typography>
            </Grid>
            <Grid width={"40%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Email
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.email || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid height={"40%"} display={"flex"} gap={1}>
            <Grid width={"29%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                User Role
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.userRole || ""}
              </Typography>
            </Grid>
            <Grid width={"29%"}>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Department
              </Typography>
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {user?.department || ""}
              </Typography>
            </Grid>
            <Grid
              width={"29%"}
              display={"flex"}
              flexDirection={"column"}
              gap={1}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.newGreyText,
                  fontSize: theme.font?.fontSize.cardHeader,
                  fontWeight: theme.font?.fontWeight.slightThick,
                }}
              >
                Status
              </Typography>
              <Typography
                fontSize={theme.font?.fontSize.tableBody}
                sx={{
                  textAlign: "center",
                  color:
                    user?.status === filterConstants.Active
                      ? theme?.color?.success
                      : theme?.color?.error,
                  backgroundColor:
                    user?.status === filterConstants.Active
                      ? theme?.color?.successLight
                      : theme.color?.errorLight,
                  borderRadius: "13px",
                  fontFamily: theme.font?.fontFamily.primary,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                minWidth={"40%"}
                maxWidth={"40%"}
              >
                {`* ${user?.status}` || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            display={"flex"}
            width={"100%"}
            justifyContent={"space-between"}
            height={"20%"}
          >
            {getUserPermissions("update") && (
              <CommonButton
                buttonTitle="Update Profile"
                color="secondary"
                variant="text"
                onClick={openUpdate ? () => openUpdate() : () => {}}
              />
            )}

            {getUserPermissions("delete") && (
              <CommonButton
                buttonTitle="Delete User"
                onClick={deleteUser}
                color="error"
              />
            )}
          </Grid>
        </Grid>
        {showModal &&
          (uploadError ? (
            <BasicModal
              title={"Something went wrong"}
              success={false}
              setState={setShowModal}
            />
          ) : (
            <BasicModal
              title={"Deleted user Successfully!"}
              success={true}
              setState={setShowModal}
            />
          ))}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
};

export default UpdateUser;
